define('payment/withdrawFee',['jquery', 'boxes/helpers/tooltip', 'boxes/events/feeEvent', 'all/comeon', 'all/paymentServices-toggles'], function ($, tooltip, feeEvent, comeon,
                                                                                                                            paymentServicesToggles) {
    'use strict';

    var withdrawSummary = {};
    var withdrawbox = {};

    function getWithdrawBalanceURL() {
        return paymentServicesToggles.useNewPaymentFormDataService() ? '/PaymentFormDataService/getWithdrawBalance' : '/pp?flow=GetWithdrawBalance';
    }

    function fetchFeesFromServer(methodId, amount, currency, accountId) {
        var data = {
            method: methodId,
            currency: currency,
            aid: accountId,
            amount: amount,
            paymentOperation: 'withdraw'
        };

		var feeUrl = '/PaymentFormDataService/geWithdrawFeesAndLimits';
		if (paymentServicesToggles.useOldPaymentFormFlows()) {
			feeUrl = '/pp?flow=GetPaymentSummary';
		}

        var ajaxPromise = comeon.promise.create();
		$.get(feeUrl, data, function (dataResult) {
            ajaxPromise.resolve(updateFees(withdrawbox, dataResult, currency));
        });
        return ajaxPromise.promise();
    }

    function updateBalance(withdraw, dataFee){
        $.get(getWithdrawBalanceURL(), function (data) {
            var totalBalance = parseFloat(data.PARAM_BALANCE_TOTAL);
            var bonusFreeMoneyBalance = parseFloat(data.PARAM_BONUS_FREE_MONEY_BALANCE);
            var bonusMoneyLockedBalance = parseFloat(data.PARAM_BONUS_LOCKED_MONEY_BALANCE);
            var fee = parseFloat(dataFee.PARAM_FEE_AMOUNT);

			var availableBalanceToWithdraw = totalBalance - bonusMoneyLockedBalance - bonusFreeMoneyBalance - fee;

			if(availableBalanceToWithdraw < 0) {
                availableBalanceToWithdraw = 0;
            }
            withdraw.$box.find('.balance .unlocked').text((availableBalanceToWithdraw).toFixed(2) + ' ' + dataFee.PARAM_PLAYER_CURRENCY);
        });
    }

    function updateFees(withdraw, data) {
        var $feeBox = withdraw.$box.find('.fee-box');

        //update the fee label
        showExchangeRate($feeBox, data);
        generateFeeBox($feeBox, data);
        updateBalance(withdraw, data);
        withdraw.model.providerId = data.PROVIDER;
        return data;
    }


    function generateFeeBox($feeBox, feeData) {
        generateFee($feeBox, feeData);
        $feeBox.find('.withdraw-amount').text(feeData.PARAM_AMOUNT + ' ' + feeData.PARAM_PLAYER_CURRENCY);
        $feeBox.find('.total-amount').text(feeData.PARAM_TOTAL_AMOUNT + ' ' + feeData.PARAM_PLAYER_CURRENCY);
    }

    function generateFee($feeBox, feeData) {
        var $fee = $feeBox.find('.fee');
        var $feeMoney = $feeBox.find('.fee-money');
        $feeMoney.text(feeData.PARAM_FEE_AMOUNT + ' ' + feeData.PARAM_PLAYER_CURRENCY);
        $fee.show();
        $feeMoney.show();

    }

    function showExchangeRate($feeBox, feeData) {
        if (feeData.PARAM_RATE === 1.0) {
            $feeBox.find('.rate-label').hide();
            $feeBox.find('.rate-value').hide();
        } else {
            $feeBox.find('.rate-value').text((Math.round(parseFloat(feeData.PARAM_RATE) * 1000) / 1000 ) + ' ' + feeData.PARAM_CURRENCY_ISO + '/'
                + feeData.PARAM_PLAYER_CURRENCY);
            $feeBox.find('.rate-label').show();
            $feeBox.find('.rate-value').show();
        }
    }

    function updateFee(methodId, amount, currency, accountId) {
        return fetchFeesFromServer(methodId, amount, currency, accountId);
    }

    withdrawSummary.init = function(withdrawReference){
        withdrawbox = withdrawReference;
    };

    withdrawSummary.updateFeesBox = function(methodId, amount, currency, formTemplateCode, accountId){
        if (!isNaN(parseFloat(amount)) && isFinite(amount)) {
            $.when(updateFee(methodId, amount, currency, accountId)).done(function (data) {
                withdrawbox.$controller.trigger(feeEvent.UPDATE_TOOLTIP, data);
            });
        }
    };

    withdrawSummary.resetFees = function(methodId, currency, formTemplateCode, accountId){
        var promise = comeon.promise.create();
        $.when(updateFee(methodId, 0, currency, accountId)).done(function () {
            var $amountBox = withdrawbox.$box.find('.amount-box');
            tooltip.hidePopover($amountBox);
            promise.resolve();
        });
        return promise.promise();
    };

    return withdrawSummary;
});

